'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharespaceProjects = exports.getGroupedRecipients = exports.getRecipients = exports.getProjectData = exports.getProjects = exports.getPreparedFilteredProjects = exports.getPreparedProjects = exports.getVideoProjects = exports.getAudioProjects = exports.getSharespaces = exports.getNewsletters = exports.getPartTracks = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _reselect = require('reselect');

var _projects = require('helpers/projects');

var _recipients = require('helpers/recipients');

var _Playlists = require('helpers/Playlists');

var _pagination = require('helpers/pagination');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getRecipients = function _getRecipients(state) {
  return state.project.recipientsListData;
}; /* Projects reselect */

var _getProject = function _getProject(state) {
  return state.project.projectData;
};
var _getNewsletters = function _getNewsletters(state) {
  return state.projects.projectsData.newsletters;
};
var _getSharespaces = function _getSharespaces(state) {
  return state.projects.projectsData.sharespace;
};
var _getAudioProjects = function _getAudioProjects(state) {
  return state.projects.projectsData.audio;
};
var _getVideoProjects = function _getVideoProjects(state) {
  return state.projects.projectsData.video;
};
var _getActiveOrder = function _getActiveOrder(state) {
  return state.projects.activeOrder;
};
var _getOrder = function _getOrder(state) {
  return state.projects.order;
};
var _getKw = function _getKw(state) {
  return state.projects.kw;
};
var _getProjectsType = function _getProjectsType(state, props) {
  return props.projectType;
};
var _getSSProjects = function _getSSProjects(state) {
  return state.project.ssProjectsListData;
};
var _getMediaList = function _getMediaList(state) {
  return state.project.mediaListData;
};
var _getProjectsListPage = function _getProjectsListPage(state) {
  return state.projects.projectsListPage;
};

var getPartTracks = exports.getPartTracks = (0, _reselect.createSelector)([_getMediaList], function (tracks) {
  return (0, _Playlists.getPartTracks)(tracks);
});

var getProcessedNewsletters = (0, _reselect.createSelector)([_getNewsletters], _projects.processProjects);
var getProcessedSharespaces = (0, _reselect.createSelector)([_getSharespaces], _projects.processProjects);
var getProcessedAudioProjects = (0, _reselect.createSelector)([_getAudioProjects], _projects.processProjects);
var getProcessedVideoProjects = (0, _reselect.createSelector)([_getVideoProjects], _projects.processProjects);

var getNewsletters = exports.getNewsletters = (0, _reselect.createSelector)([getProcessedNewsletters, _getActiveOrder, _getOrder, _getKw], function () {
  return _projects.getFilteredProjects.apply(undefined, arguments);
});

var getSharespaces = exports.getSharespaces = (0, _reselect.createSelector)([getProcessedSharespaces, _getActiveOrder, _getOrder, _getKw], function () {
  return _projects.getFilteredProjects.apply(undefined, arguments);
});

var getAudioProjects = exports.getAudioProjects = (0, _reselect.createSelector)([getProcessedAudioProjects, _getActiveOrder, _getOrder, _getKw], function () {
  return _projects.getFilteredProjects.apply(undefined, arguments);
});

var getVideoProjects = exports.getVideoProjects = (0, _reselect.createSelector)([getProcessedVideoProjects, _getActiveOrder, _getOrder, _getKw], function () {
  return _projects.getFilteredProjects.apply(undefined, arguments);
});

var getProjectsOfType = (0, _reselect.createSelector)([_getProjectsType, _getSharespaces, _getAudioProjects, _getVideoProjects], function (type, sharespaces, audioProjects, videoProjects) {
  var _types;

  var types = (_types = {}, (0, _defineProperty3.default)(_types, _projects.projectTypes.sharespace, sharespaces), (0, _defineProperty3.default)(_types, _projects.projectTypes.audio, audioProjects), (0, _defineProperty3.default)(_types, _projects.projectTypes.video, videoProjects), (0, _defineProperty3.default)(_types, 'all', [].concat((0, _toConsumableArray3.default)(audioProjects), (0, _toConsumableArray3.default)(videoProjects), (0, _toConsumableArray3.default)(sharespaces))), _types);
  return types[type] || audioProjects;
});

var getPreparedProjects = exports.getPreparedProjects = (0, _reselect.createSelector)([getProjectsOfType], _projects.prepareProjects);

var getPreparedFilteredProjects = exports.getPreparedFilteredProjects = (0, _reselect.createSelector)([getPreparedProjects, _getActiveOrder, _getOrder, _getKw], function () {
  return _projects.getFilteredProjects.apply(undefined, arguments);
});

var getProjects = exports.getProjects = (0, _reselect.createSelector)([getPreparedFilteredProjects, _getProjectsListPage], function (projects, page) {
  var _getFromTo = (0, _pagination.getFromTo)({ page: page, limit: _projects.pageLimit }),
      from = _getFromTo.from,
      to = _getFromTo.to;

  var countAll = projects.length;
  return {
    projects: (0, _projects.processProjects)(projects.slice(from, to)),
    countAll: countAll
  };
});

var getProjectData = exports.getProjectData = (0, _reselect.createSelector)([_getProject], function (project) {
  return (0, _projects.processProject)(project);
});

var getRecipients = exports.getRecipients = (0, _reselect.createSelector)([_getRecipients], _recipients.processRecipients);

var getGroupedRecipients = exports.getGroupedRecipients = (0, _reselect.createSelector)([_getRecipients], _recipients.groupRecipients);

var getSharespaceProjects = exports.getSharespaceProjects = (0, _reselect.createSelector)([_getSSProjects], function (projects) {
  return (0, _projects.processProjects)(projects);
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/projects.js
// module id = 136
// module chunks = 1